import { getPezDefaultListViewportHeight } from '../helpers/photo-effects-list-resize'
import { PEZ_EFFECTS_LIST_RESIZE_HANDLE_HEIGHT } from './photo-effect-row-layout'

/**
 * Figma PEZ popover (node 113-7446) — copied CSS:
 * width 340, height 450, padding/gap 16, radius 8, border #E5E5E5, shadow/md.
 */
export const POPOVER_WIDTH = 340
/** Fallback height before first layout measure (Figma default shell + resize handle). */
export const POPOVER_HEIGHT =
  16 * 2 +
  32 +
  8 +
  28 +
  8 +
  getPezDefaultListViewportHeight() +
  PEZ_EFFECTS_LIST_RESIZE_HANDLE_HEIGHT
/** Inner “effects in view” frame from Figma (308×342, list column 295px). */
export const POPOVER_GAP = 12
/** Above crop/text-on-path toolbars (9999) and their nested popovers (10000). */
export const PHOTO_EFFECTS_Z_INDEX = 10050

export const FIGMA_SHADOW_MD =
  '0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -2px rgba(0, 0, 0, 0.1)'
